import { Component, OnInit } from '@angular/core';
import { UpdateService } from './library/services/update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ezyhire-candidate';

  constructor(private updateService: UpdateService) {}

  ngOnInit(): void {
    // Initialize update service - it will automatically handle updates
    console.log('App initialized with service worker support');
  }
}
